import React from "react";
import {
  Box,
  Stack,
  Skeleton,
  useMediaQuery,
  useTheme,
  Container,
} from "@mui/material";

export default function SmartGadgetsSctSk() {
  const theme = useTheme();

  const isSmall = useMediaQuery(theme.breakpoints.down("xlg"));
  const isMedium = useMediaQuery(theme.breakpoints.between("xlg", "xxl"));
  const isLarge = useMediaQuery(theme.breakpoints.between("xxl", "exl"));
  const isExtraLarge = useMediaQuery(theme.breakpoints.up("exl"));

  let maxItems = 1;
  if (isMedium) maxItems = 2;
  if (isLarge) maxItems = 4;
  if (isExtraLarge) maxItems = 6;

  const items = Array.from({ length: maxItems + 1 }).map((_, index) => (
    <Box
      key={index}
      sx={{
        width: { xs: 80, sm: 100, md: 120, lg: 130 },
        height: { xs: 80, sm: 100, md: 120, lg: 130 },
        borderRadius: "1rem",
        overflow: "hidden",
      }}
    >
      <Skeleton variant="rectangular" width="100%" height="100%" />
    </Box>
  ));

  return (
    <Container maxWidth={"exl"}>
      <Stack
        direction={"row"}
        sx={{
          alignItems: "center",
          position: "relative",
          p: "1rem",
          minHeight: { xs: "80px", md: "140px" },
        }}
      >
        {/* TITLE + BUTTON */}
        <Stack
          direction={{ xs: "row", lg: "column" }}
          sx={{
            textAlign: "center",
            position: { xs: "absolute", lg: "static" },
            bottom: "100%",
            left: "50%",
            transform: {
              xs: "translate(-50% , -100%)",
              lg: "translate(0 , 0)",
            },
            width: { xs: "100%", lg: "auto" },
            justifyContent: { xs: "space-between", lg: "start" },
          }}
        >
          {/* TITLE */}
          <Stack
            sx={{
              width: { xs: "50%", lg: "100%" },
              alignItems: "center",
              transform: { xs: "translateX(-50%)", lg: "translateX(0)" },
            }}
          >
            <Skeleton
              sx={{ mb: 1 }}
              variant="text"
              width={80}
              height={30}
            />
            <Skeleton variant="text" width={80} height={30} />
          </Stack>

          {/* BUTTON */}
          <Skeleton
            variant="rounded"
            width={120}
            height={40}
            sx={{ mt: ".5rem", borderRadius: "10px" }}
          />
        </Stack>

        {/* CARDS ROW */}
        <Stack
          direction={"row"}
          sx={{
            gap: "1rem",
            justifyContent: { xs: "center", lg: "space-between" },
            position: "absolute",
            left: { xs: "50%", lg: "2rem" },
            transform: {
              xs: "translate(-50% , -30%)",
              lg: "translate(0 , 0)",
            },
          }}
        >
          {items}
        </Stack>
      </Stack>
    </Container>
  );
}
